module.exports = __webpack_public_path__ + "img/icon_card14.a087db32.png";